<script>
    import SubPortfolio from "../molecules/SubPortfolio.svelte";
    import { getConnectorValue} from "../query";
    export let subPortfolio;
    export let maxValue;

    let isConnected = getConnectorValue();
</script>

{#each subPortfolio as elem}
    {#if elem.media.length > 0  || isConnected}
        <SubPortfolio maxValue={maxValue} media={elem} />
    {/if}
{/each}